import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ErrorModal } from '../../../../components/modals/error-modal';
import ModalPortal from '../../../../components/modal-portal';
import { messages } from '../../../../store/orders/messages';

const GetOrdersFailModal = ({ onClose }) => {
  return (
    <ModalPortal onClose={onClose}>
      <ErrorModal
        message={<FormattedMessage {...messages.orderGridFilterOrderFailureMessage} />}
        modalFrameworkMethods={{ onClose }}
        title={<FormattedMessage {...messages.orderGridFilterOrderFailureTitle} />}
      />
    </ModalPortal>
  );
};

GetOrdersFailModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export { GetOrdersFailModal };
